<script lang="ts">
    import cn from 'classnames';

    import { globalStore } from '@components/stores';
    import { Dialog } from '@components/ui/dialog';
    import { LL } from '@i18n/i18n-svelte';
    import { Font, FontTypes } from '@uikit/font';
    import { SpinnerCircle } from '@uikit/spinner-circle';

    import s from './spinner-dialog.module.css';
</script>

<Dialog classes={cn(s.root, { [s.desktop]: $globalStore.isDesktopSite })}>
    <SpinnerCircle size={32} classes={s.loader} borderWidth={4} />
    <Font
            type={FontTypes.Type.h3}
            color={FontTypes.Color.Invert}
            tagName={FontTypes.TagName.h3}
            isBold
            className={s.title}
            attrs={{ 'data-testid': 'title' }}
    >
        {$LL.payment.spinnerDialog.title()}
    </Font>
    <Font
            type={FontTypes.Type.body}
            color={FontTypes.Color.Secondary}
            tagName={FontTypes.TagName.p}
            className={s.subtitle}
            attrs={{ 'data-testid': 'subtitle' }}
    >
        {$LL.payment.spinnerDialog.text()}
    </Font>
</Dialog>